import script from "./TheToast.vue?vue&type=script&setup=true&lang=js"
export * from "./TheToast.vue?vue&type=script&setup=true&lang=js"

import "./TheToast.vue?vue&type=style&index=0&id=fed6f348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fed6f348"]])

export default __exports__